/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsVignetteResubmissionTemplateData } from '../../models/mail-params-vignette-resubmission-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendVignetteResubmissionMail$Params {
      body: MailParamsVignetteResubmissionTemplateData
}

export function sendVignetteResubmissionMail(http: HttpClient, rootUrl: string, params: SendVignetteResubmissionMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendVignetteResubmissionMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendVignetteResubmissionMail.PATH = '/sendMail/vignette-resubmission';
